import React from "react";

/**
 * Shared generate CTA used at the bottom of every Studio detail page. Just a
 * button with a loading state — nothing fancy. Styled through the Studio's
 * own CSS.
 */
export default function StudioGenerateButton({
  onClick,
  disabled,
  loading,
  label = "Generate",
  loadingLabel = "Generating...",
}) {
  return (
    <button
      className="studio-generate-btn"
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? loadingLabel : label}
    </button>
  );
}
